import store from '@/store'

export default function(to, from, next) {
    console.log('[PageLayoutChanger] Guarding start.')

    if (to.name === 'sampling' || to.name === 'no-sampling') {
        store.dispatch('layout/setLayoutClasses', 'is-simple', { root: true })
    }
    else if(from.name === 'sampling') {
        store.dispatch('layout/clearLayoutClasses', {}, { root: true })
    }

    console.log('[PageLayoutChanger] Guarded.')

    next()
}